import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "bg-white position-relative overflow-auto mw-100",
  style: {"max-height":"670px"}
}
const _hoisted_2 = { class: "table table-bordered mb-6" }
const _hoisted_3 = { class: "sticky-top bg-white" }
const _hoisted_4 = { class: "position-relative border-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3 text-nowrap" }, " № п/п ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3 text-nowrap" }, " id ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3 text-nowrap" }, " Дата создания ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3 text-nowrap" }, " Организация/Юр.лицо ", -1)
const _hoisted_9 = { class: "py-2 px-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, " Участок ", -1)
const _hoisted_11 = {
  height: "16px",
  style: {"enable-background":"new 0 0 401.998 401.998"},
  viewBox: "0 0 401.998 401.998",
  width: "16px",
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_12 = ["fill-opacity"]
const _hoisted_13 = ["fill-opacity"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { class: "py-2 px-3" }, " Подразделение ", -1)
const _hoisted_15 = { class: "py-2 px-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, " ФИО ", -1)
const _hoisted_17 = {
  height: "16px",
  style: {"enable-background":"new 0 0 401.998 401.998"},
  viewBox: "0 0 401.998 401.998",
  width: "16px",
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_18 = ["fill-opacity"]
const _hoisted_19 = ["fill-opacity"]
const _hoisted_20 = { class: "py-2 px-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, " Должность ", -1)
const _hoisted_22 = {
  height: "16px",
  style: {"enable-background":"new 0 0 401.998 401.998"},
  viewBox: "0 0 401.998 401.998",
  width: "16px",
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_23 = ["fill-opacity"]
const _hoisted_24 = ["fill-opacity"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("th", {
  class: "py-2 px-3",
  colspan: "2"
}, " Статус ", -1)
const _hoisted_26 = { class: "py-2 px-3" }
const _hoisted_27 = { class: "py-2 px-3" }
const _hoisted_28 = { class: "py-2 px-3" }
const _hoisted_29 = { class: "py-2 px-3" }
const _hoisted_30 = { class: "py-2 px-3" }
const _hoisted_31 = { class: "py-2 px-3" }
const _hoisted_32 = { class: "py-2 px-3" }
const _hoisted_33 = { class: "py-2 px-3" }
const _hoisted_34 = {
  class: "py-2 px-2",
  style: {"min-width":"120px"}
}
const _hoisted_35 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_36 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_37 = {
  class: "py-2 px-3",
  style: {"width":"50px"}
}
const _hoisted_38 = { class: "btn btn-sm d-flex justify-content-center align-items-center" }

import { PropType } from "vue";
import { userStore } from "@/store/userStore";
import { IEmployee } from "@/@types/IEmployee";
import formatDate from '@/utils/formatDate';
import { STATUS_COLLECTION } from '@depo/constants/employee';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmployeeComponent',
  props: {
    employees: {
        type: Array<IEmployee>,
        required: true,
    },
    statuses: {
        type: Array<Record<string, number | string>>,
        required: true,
    },
    onEdit: {
        type: Function as PropType<(employee: IEmployee) => void>,
        required: true,
    },
    onChangeSort: {
        type: Function as PropType<(arg1: string) => void>,
        required: true,
    },
    onFillOpacity: {
        type: Function as PropType<(col: string, by: string) => ('1.0' | '0.5')>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const { user } = userStore();

return (_ctx: any,_cache: any) => {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_dropdown_ui = _resolveComponent("dropdown-ui")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", _hoisted_3, [
        _createElementVNode("tr", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("th", _hoisted_9, [
            _createElementVNode("div", {
              class: "d-flex align-items-center cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (props.onChangeSort('employeePlot')))
            }, [
              _hoisted_10,
              (_openBlock(), _createElementBlock("svg", _hoisted_11, [
                _createElementVNode("path", {
                  d: "M73.092,164.452h255.813c4.949,0,9.233-1.807,12.848-5.424c3.613-3.616,5.427-7.898,5.427-12.847\n                                    c0-4.949-1.813-9.229-5.427-12.85L213.846,5.424C210.232,1.812,205.951,0,200.999,0s-9.233,1.812-12.85,5.424L60.242,133.331\n                                    c-3.617,3.617-5.424,7.901-5.424,12.85c0,4.948,1.807,9.231,5.424,12.847C63.863,162.645,68.144,164.452,73.092,164.452z",
                  "fill-opacity": props.onFillOpacity('employeePlot', 'asc')
                }, null, 8, _hoisted_12),
                _createElementVNode("path", {
                  d: "M328.905,237.549H73.092c-4.952,0-9.233,1.808-12.85,5.421c-3.617,3.617-5.424,7.898-5.424,12.847\n                                    c0,4.949,1.807,9.233,5.424,12.848L188.149,396.57c3.621,3.617,7.902,5.428,12.85,5.428s9.233-1.811,12.847-5.428l127.907-127.906\n                                    c3.613-3.614,5.427-7.898,5.427-12.848c0-4.948-1.813-9.229-5.427-12.847C338.139,239.353,333.854,237.549,328.905,237.549z",
                  "fill-opacity": props.onFillOpacity('employeePlot', 'desc')
                }, null, 8, _hoisted_13)
              ]))
            ])
          ]),
          _hoisted_14,
          _createElementVNode("th", _hoisted_15, [
            _createElementVNode("div", {
              class: "d-flex align-items-center cursor-pointer",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (props.onChangeSort('employeeName')))
            }, [
              _hoisted_16,
              (_openBlock(), _createElementBlock("svg", _hoisted_17, [
                _createElementVNode("path", {
                  d: "M73.092,164.452h255.813c4.949,0,9.233-1.807,12.848-5.424c3.613-3.616,5.427-7.898,5.427-12.847\n                                    c0-4.949-1.813-9.229-5.427-12.85L213.846,5.424C210.232,1.812,205.951,0,200.999,0s-9.233,1.812-12.85,5.424L60.242,133.331\n                                    c-3.617,3.617-5.424,7.901-5.424,12.85c0,4.948,1.807,9.231,5.424,12.847C63.863,162.645,68.144,164.452,73.092,164.452z",
                  "fill-opacity": props.onFillOpacity('employeeName', 'asc')
                }, null, 8, _hoisted_18),
                _createElementVNode("path", {
                  d: "M328.905,237.549H73.092c-4.952,0-9.233,1.808-12.85,5.421c-3.617,3.617-5.424,7.898-5.424,12.847\n                                    c0,4.949,1.807,9.233,5.424,12.848L188.149,396.57c3.621,3.617,7.902,5.428,12.85,5.428s9.233-1.811,12.847-5.428l127.907-127.906\n                                    c3.613-3.614,5.427-7.898,5.427-12.848c0-4.948-1.813-9.229-5.427-12.847C338.139,239.353,333.854,237.549,328.905,237.549z",
                  "fill-opacity": props.onFillOpacity('employeeName', 'desc')
                }, null, 8, _hoisted_19)
              ]))
            ])
          ]),
          _createElementVNode("th", _hoisted_20, [
            _createElementVNode("div", {
              class: "d-flex align-items-center cursor-pointer",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (props.onChangeSort('employeePost')))
            }, [
              _hoisted_21,
              (_openBlock(), _createElementBlock("svg", _hoisted_22, [
                _createElementVNode("path", {
                  d: "M73.092,164.452h255.813c4.949,0,9.233-1.807,12.848-5.424c3.613-3.616,5.427-7.898,5.427-12.847\n                                    c0-4.949-1.813-9.229-5.427-12.85L213.846,5.424C210.232,1.812,205.951,0,200.999,0s-9.233,1.812-12.85,5.424L60.242,133.331\n                                    c-3.617,3.617-5.424,7.901-5.424,12.85c0,4.948,1.807,9.231,5.424,12.847C63.863,162.645,68.144,164.452,73.092,164.452z",
                  "fill-opacity": props.onFillOpacity('employeePost', 'asc')
                }, null, 8, _hoisted_23),
                _createElementVNode("path", {
                  d: "M328.905,237.549H73.092c-4.952,0-9.233,1.808-12.85,5.421c-3.617,3.617-5.424,7.898-5.424,12.847\n                                    c0,4.949,1.807,9.233,5.424,12.848L188.149,396.57c3.621,3.617,7.902,5.428,12.85,5.428s9.233-1.811,12.847-5.428l127.907-127.906\n                                    c3.613-3.614,5.427-7.898,5.427-12.848c0-4.948-1.813-9.229-5.427-12.847C338.139,239.353,333.854,237.549,328.905,237.549z",
                  "fill-opacity": props.onFillOpacity('employeePost', 'desc')
                }, null, 8, _hoisted_24)
              ]))
            ])
          ]),
          _hoisted_25
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.employees, (employee, employeeIdx) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: employee.id
          }, [
            _createElementVNode("td", _hoisted_26, _toDisplayString(employeeIdx + 1), 1),
            _createElementVNode("td", _hoisted_27, _toDisplayString(employee.id), 1),
            _createElementVNode("td", _hoisted_28, _toDisplayString(_unref(formatDate)(employee.createdAt)), 1),
            _createElementVNode("td", _hoisted_29, _toDisplayString(employee.supplierName || employee.depoName), 1),
            _createElementVNode("td", _hoisted_30, _toDisplayString(employee?.department?.subdivision?.name || employee.subdivision), 1),
            _createElementVNode("td", _hoisted_31, _toDisplayString(employee?.department?.name || employee.employeePlot), 1),
            _createElementVNode("td", _hoisted_32, _toDisplayString(employee.employeeName), 1),
            _createElementVNode("td", _hoisted_33, _toDisplayString(employee.employeePost), 1),
            _createElementVNode("td", _hoisted_34, [
              _createTextVNode(_toDisplayString(_unref(STATUS_COLLECTION).find(s => s.VALUE === +employee.employeeStatus)?.LABEL || 'Неизвестный статус') + " ", 1),
              (employee.hiredAt)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, " Дата принятия: " + _toDisplayString(_unref(formatDate)(employee.hiredAt)), 1))
                : _createCommentVNode("", true),
              (employee.firedAt)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, " Дата увольнения: " + _toDisplayString(_unref(formatDate)(employee.firedAt)), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", _hoisted_37, [
              (employee.status !== 4)
                ? (_openBlock(), _createBlock(_component_dropdown_ui, { key: 0 }, {
                    button: _withCtx(() => [
                      _createElementVNode("button", _hoisted_38, [
                        _createVNode(_component_vue_feather, {
                          size: "14px",
                          type: "more-vertical"
                        })
                      ])
                    ]),
                    list: _withCtx(() => [
                      (_unref(user).isAdmin || _unref(user).isKadry || _unref(user).isSuperAdmin)
                        ? (_openBlock(), _createBlock(_component_button_ui, {
                            key: 0,
                            class: "dropdown-item cursor-pointer",
                            onClick: ($event: any) => (props.onEdit(employee))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Редактировать ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})